<script lang="ts">
	//UI
	import ComponentCover from "@hitit/hub/src/v7/components/common/ComponentCover.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import { AdaptiveTextInput, Card } from "@hitit/new_ui";
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	import { notifications, t } from "@hitit/hub/src/stores";
	import StoreNameValue from "@hitit/hub/src/v7/components/store/StoreNameValue.svelte";
	//Utils

	//Types
	//Props
	export let coverStatus = false;
	export let editmode = false;
	export let editable = false;
	//Constants
	const vanStatusTypes = ["KICC", "KCP", "없음"];
	const agencyStatusTypes = ["힛잇주식회사", "기타"];
	const message = "카드단말 가맹 정보 저장 도중 문제가 발생하였습니다."
	//Variables
	let vanType = "-";
	let agencyType = "-";
	let agencyValue = "";
	let customerServiceCenter = "-";
	let loading = false;
	let error = "";
	//Functions
	async function actionHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}

		try {
			error = "";
			loading = true;
			alert('아직 사용할 수 없는 기능입니다. 서버에 저장되지 않습니다.')
			editmode = false;
		} catch (error) {
			console.log(error);
			notifications.append("ERROR", message, "", undefined, "WARNING");
		} finally {
			loading = false;
		}
	}

	function vanClickHandler(van: string) {
		vanType = van;
	}

	function agencyClickHandler(agency: string) {
		agency === "힛잇주식회사"
			? (customerServiceCenter = "02-3705-7070")
			: (customerServiceCenter = "");
		agencyType = agency;
	}
	//Do
</script>

<div class="root-wrapper">
	<Card noPadding>
		<div class="container" t-id="CardMembershipInfo">
			{#if coverStatus}
				<ComponentCover />
			{/if}
			{#if loading}
				<ComponentLoading coverMode />
			{/if}
			{#if editable}
				<div class="action" on:click={actionHandler}>
					<span>{editmode ? $t("global.done") : $t("global.edit")}</span>
					<img
						src={editmode ? SaveIcon : EditIcon}
						alt={editmode ? "save" : "edit"}
					/>
				</div>
			{/if}
			<p class="title">
				{$t("hub.store.cardmembershipinfo.cardmembershipinfo")}
			</p>
			{#if editmode && error}
				<p class="error">{error}</p>
			{/if}
			<StoreNameValue
				name={$t("hub.store.cardmembershipinfo.van")}
				editmode={editmode}
				value={vanType}
			>
				<div slot="input" class="box">
					{#each vanStatusTypes as van}
						<button
							class="button"
							class:selected={vanType === van}
							on:click={() => vanClickHandler(van)}
						>
							{van}
						</button>
					{/each}
				</div>
			</StoreNameValue>
			<StoreNameValue
				name={$t("hub.store.cardmembershipinfo.agency")}
				editmode={editmode}
				value={agencyType}
			>
				<div slot="input" class="box agency-button-wrapper">
					<div class="button-box">
						{#each agencyStatusTypes as agency}
							<button
								class="button"
								class:selected={agencyType === agency}
								on:click={() => agencyClickHandler(agency)}
							>
								{agency}
							</button>
						{/each}
					</div>
					{#if agencyType === "기타"}
						<div class="input">
							<AdaptiveTextInput
								bind:value={agencyValue}
								backgroundColor={"#f0f0f4"}
								on:input
								clearCallback={() => (agencyValue = "")}
							/>
						</div>
					{/if}
				</div>
			</StoreNameValue>
			<StoreNameValue
				value={customerServiceCenter}
				name={$t("hub.store.cardmembershipinfo.customer_service_center")}
				editmode={editmode}
			>
				<div slot="input">
					<div class="input">
						<AdaptiveTextInput
							bind:value={customerServiceCenter}
							backgroundColor={"#f0f0f4"}
							on:input
							clearCallback={() => (customerServiceCenter = "")}
						/>
					</div>
				</div>
			</StoreNameValue>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.root-wrapper {
		width: 100%;
	}
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		gap: 20px;
		.title {
			font-size: 1.25rem;
			font-weight: 600;
			color: #46474b;
		}
		.action {
			display: flex;
			gap: 10px;
			align-items: center;
			position: absolute;
			right: 10px;
			top: 10px;
			color: #6d6f76;
			font-weight: 500;

			&:hover {
				cursor: pointer;
			}
			img {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
		}

		.box {
			display: flex;
			gap: 10px;
			.button-box {
				display: flex;
				gap: 10px;
			}

			.button {
				width: auto;
				height: 40px;
				padding: 0px 20px 0px 20px;
				background-color: inherit;
				border: 1px solid #bcbfc3;
				border-radius: 20px;
				@include appleAdjustTextForSize(16, true);

				&.selected {
					color: white;
					border: none;
					background-color: #6d6f76;
				}
				&:hover {
					cursor: pointer;
				}
			}
		}

		.agency-button-wrapper {
			display: flex;
			flex-direction: column;
		}

		.input {
			flex-grow: 1;
			max-width: 100%;
			height: 31px;
			color: #46474b;
			font-size: 1rem;
		}
	}
	@include DesktopSize {
		.root-wrapper {
			max-height: 415px;
		}
		.container {
			padding: 30px;
			gap: 30px;
			.title {
				font-size: 2.125rem;
			}
			.action {
				top: 20px;
				right: 20px;
				font-size: 1.25rem;
			}

			.agency-box {
				flex-direction: row;
			}
			.box {
				.button {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.agency-button-wrapper {
				flex-direction: row;
			}
			.input {
				height: 40px;
				width: 100%;
				font-size: 1.25rem;
			}
		}
	}
</style>
